import { createFileRoute } from '@tanstack/react-router';
import { GiveawaySetupPage } from '@/features/marketing';

/** New campaign › A giveaway entry: the giveaway setup screen, creating the campaign on its first save. */
export const Route = createFileRoute('/_auth/$orgId/marketing/campaigns_/new_/giveaway')({
  component: NewGiveawayRoute,
});

function NewGiveawayRoute() {
  const { orgId } = Route.useParams();
  return <GiveawaySetupPage orgId={orgId} campaignId={null} />;
}
